import { createSlice } from '@reduxjs/toolkit';

export const notificationSlice = createSlice({
  name: 'notification',
  initialState: {
    count: 0,
  },
  reducers: {
    handleNotification: (state, action) => {
      state.count = action.payload;
    },
  },
});

export const { handleNotification } = notificationSlice.actions;

export default notificationSlice.reducer;
